import { render, staticRenderFns } from "./20welcomJie.vue?vue&type=template&id=3f1a3843&scoped=true&"
import script from "./20welcomJie.vue?vue&type=script&lang=js&"
export * from "./20welcomJie.vue?vue&type=script&lang=js&"
import style0 from "./20welcomJie.vue?vue&type=style&index=0&id=3f1a3843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1a3843",
  null
  
)

export default component.exports